import { Link } from "react-router-dom"
import { Button } from "reactstrap"
import ThemeModal from "./ThemeModal"

const DuplicateCheckModal = ({
  isOpen = false,
  toggle = () => {},
  title = "Existing Records Found",
  warningText = "",
  items = [],
  proceedLabel = "Proceed Anyway",
  onProceed = () => {},
  isProceeding = false,
}) => {
  return (
    <ThemeModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="md"
      footer={
        <div className="d-flex gap-2 justify-content-end w-100">
          <Button color="light" onClick={toggle} disabled={isProceeding}>
            Cancel
          </Button>
          <Button color="warning" onClick={onProceed} disabled={isProceeding}>
            {isProceeding ? (
              <>
                <i className="mdi mdi-loading mdi-spin me-1" />
                Processing...
              </>
            ) : (
              <>
                <i className="mdi mdi-alert-outline me-1" />
                {proceedLabel}
              </>
            )}
          </Button>
        </div>
      }
    >
      <div className="alert alert-warning d-flex align-items-start gap-2 mb-3">
        <i className="bx bx-error-circle fs-5 mt-1 flex-shrink-0" />
        <div className="small">{warningText}</div>
      </div>

      <div
        className="border rounded overflow-hidden"
        style={{ maxHeight: 260, overflowY: "auto" }}
      >
        {items.map((item, idx) => (
          <div
            key={item.id}
            className={`d-flex justify-content-between align-items-center px-3 py-2${idx < items.length - 1 ? " border-bottom" : ""}`}
          >
            <div>
              <div className="fw-semibold text-dark">{item.label}</div>
              {item.subLabel && (
                <small className="text-muted">{item.subLabel}</small>
              )}
            </div>
            <Link
              to={item.linkTo}
              onClick={toggle}
              className="btn btn-sm btn-soft-primary ms-2 flex-shrink-0"
              title="View"
            >
              <i className="bx bx-link-external" />
            </Link>
          </div>
        ))}
      </div>
    </ThemeModal>
  )
}

export default DuplicateCheckModal
